import { CognitoRefreshToken, CognitoUserSession } from 'amazon-cognito-identity-js';

// Refresh the access token when it is within this long of expiring, so in-flight work
// (e.g. a long form submission) never hits a 401 mid-save
export const REFRESH_THRESHOLD_MS = 5 * 60 * 1000;

// How often to check whether the token is approaching expiry
export const REFRESH_CHECK_INTERVAL_MS = 60 * 1000;

export const isTokenNearExpiry = (expirationSeconds: number, nowMs: number, thresholdMs: number = REFRESH_THRESHOLD_MS): boolean =>
    expirationSeconds * 1000 - nowMs <= thresholdMs;

type RefreshableCognitoUser = {
    refreshSession: (refreshToken: CognitoRefreshToken, callback: (err: unknown, session: CognitoUserSession | null) => void) => void;
};

/**
 * Forces a refresh-token exchange regardless of whether the current access token is still
 * valid. Auth.currentSession() returns the cached session untouched until it has actually
 * expired, so refreshing *before* expiry has to go through CognitoUser.refreshSession directly.
 */
export const forceRefreshSession = (user: RefreshableCognitoUser, session: CognitoUserSession): Promise<CognitoUserSession> =>
    new Promise((resolve, reject) => {
        user.refreshSession(session.getRefreshToken(), (err, newSession) => {
            if (err || !newSession) {
                reject(err ?? new Error('refreshSession returned no session'));
            } else {
                resolve(newSession);
            }
        });
    });
